import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IBreadcrumb } from '../common/interfaces/IBreadcrumb';

@Component({
    selector: 'cpq-breadcrumb',
    templateUrl: './cpq-breadcrumb.component.html',
    styleUrls: ['./cpq-breadcrumb.component.scss'],
    standalone: false
})
export class CpqBreadcrumbComponent implements OnInit {

  /**
  * Example of the Breadcrumb:
  * [breadcrumbs]="[{ label:{ key:'translationKey1'}, url:'returnURL', queryParams: {'queryParamName1': queryParamValue1}}, {label:{ value: translationKey2}}]">
  */
  @Input() breadcrumbs: Array<IBreadcrumb>;
  constructor(public route: ActivatedRoute) { }

  ngOnInit() {
  }

}
